import actions from './actions'
import mutations from './mutations'
import forms from './forms'

const namespaced = true

const state =  {}

export default {
  namespaced,
  state,
  actions,
  mutations,
  modules: {
    forms
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/register/index.js